import { Pages } from 'constants/menu';
import type { SubPage } from 'components/left-submenu/LeftSubmenu';
import { CampaignDetailModelState } from '@urbanx/agx.campaigns.client';

interface ContractInformationSubPageOptions {
  campaignState?: CampaignDetailModelState;
}

export function getContractInformationSubPages({
  campaignState,
}: ContractInformationSubPageOptions = {}): SubPage[] {
  const subPages: SubPage[] = [
    {
      title: 'Sale Information',
      link: Pages.SALE_INFORMATION,
    },
    {
      title: 'Conditions',
      link: Pages.CONDITIONS,
    },
  ];

  if (campaignState === CampaignDetailModelState.QLD) {
    subPages.push({
      title: 'Special Conditions',
      link: Pages.SPECIAL_CONDITIONS,
    });
  }

  subPages.push(
    {
      title: 'Settlement',
      link: Pages.SETTLEMENT,
    },
    {
      title: 'Deposits',
      link: Pages.DEPOSITS,
    }
  );

  return subPages;
}
